export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_7ad4ca74-aec9-4b9f-8734-b800cdf45eee/artifacts/e5048bf0ee1513bd_eb86608c-5592-471e-afa1-203d642b5ae4.png";

export const ROLE_LABEL = { superadmin: "Super Admin", admin: "Admin", staff: "Staff", member: "Anggota" };

export const fmtAcc = (a) => (a || "").replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
export const isValidAcc = (a) => {
  if (!/^\d{12}$/.test(a)) return false;
  let sum = 0;
  [...a.slice(0, 11)].reverse().forEach((ch, i) => {
    let d = Number(ch);
    if (i % 2 === 0) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  });
  return String((10 - (sum % 10)) % 10) === a[11];
};
const RANK = { member: 0, staff: 1, admin: 2, superadmin: 3 };
export const rank = (u) => RANK[u?.role] ?? 0;
export const isStaff = (u) => rank(u) >= 1;

export const rp = (n) => "Rp" + Math.round(n || 0).toLocaleString("id-ID");

export const fmtDate = (s, opts = { day: "2-digit", month: "short", year: "numeric" }) =>
  s ? new Date(s).toLocaleDateString("id-ID", opts) : "-";

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const KIND_LABEL = {
  angsuran: "Angsuran Pinjaman",
  setoran: "Setoran Simpanan",
  biaya_admin: "Biaya Administrasi",
  transfer_bank: "Transfer ke Bank",
  transfer_member: "Transfer Sesama Anggota",
};

export const METHOD_LABEL = { transfer_bank: "Transfer Bank", qris: "QRIS", saldo: "Saldo Anggota", internal: "Internal" };

export const STATUS_STYLE = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  disetujui: "bg-emerald-50 text-emerald-700 border-emerald-200",
  aktif: "bg-emerald-50 text-emerald-700 border-emerald-200",
  lunas: "bg-blue-50 text-blue-800 border-blue-200",
  ditolak: "bg-red-50 text-red-700 border-red-200",
  nonaktif: "bg-slate-100 text-slate-600 border-slate-200",
};

export const STATUS_LABEL = { pending: "Menunggu", disetujui: "Disetujui", aktif: "Aktif", lunas: "Lunas", ditolak: "Ditolak", nonaktif: "Nonaktif" };

export function simulate(amount, tenor, rate) {
  const principal = amount / tenor;
  const interest = (amount * rate) / 100;
  const installment = Math.round(principal + interest);
  return { principal, interest, installment, total: installment * tenor, totalInterest: interest * tenor };
}
